<div class="error">
    <p class="title">
        {{ title }}
        <mat-chip [synCopyToClipboard]="correlationId" class="correlation-id">
            {{ correlationId }}
        </mat-chip>
    </p>
    <p>{{ details }}</p>
</div>
